/**
 * @generated SignedSource<<a96cf9ca7b4498df44ffd94e43c37c5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSaveNoteImageGetImageLinkMutation$variables = Record<PropertyKey, never>;
export type useSaveNoteImageGetImageLinkMutation$data = {
  readonly uploadImageLink: {
    readonly image: {
      readonly id: string;
    };
    readonly url: string;
  } | null;
};
export type useSaveNoteImageGetImageLinkMutation = {
  response: useSaveNoteImageGetImageLinkMutation$data;
  variables: useSaveNoteImageGetImageLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UploadImageLinkResponse",
    "kind": "LinkedField",
    "name": "uploadImageLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveNoteImageGetImageLinkMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useSaveNoteImageGetImageLinkMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "bcab56fecc88f17e59dbbdeb77a6449b",
    "id": null,
    "metadata": {},
    "name": "useSaveNoteImageGetImageLinkMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveNoteImageGetImageLinkMutation {\n  uploadImageLink {\n    image {\n      id\n    }\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "f93468910e96401ec6331cb615f1a115";

export default node;
